import { Divider, Heading } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { SettingsFacilitiesTable } from './SettingsFacilitiesTable';
import { useCreditFacilitiesOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Fragments
const RouteBase = () => {
  const { facilities } = useCreditFacilitiesOrThrow();
  return (
    <>
      <Heading as="h2" mb="16px" fontSize="36px" fontWeight={600}>
        Facilities
      </Heading>
      <Divider mb="40px" />
      <SettingsFacilitiesTable creditFacilities={facilities} />
    </>
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
